import { render, staticRenderFns } from "./PayoutsTable.vue?vue&type=template&id=6deb0ec0&scoped=true&"
import script from "./PayoutsTable.vue?vue&type=script&lang=js&"
export * from "./PayoutsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb0ec0",
  null
  
)

export default component.exports